export function smoothScrollToTop() {
  window.scrollTo({ top: 0, behavior: "smooth" });
}

export const scroll = {
  smoothScrollToTop,
};
